import BaseChannel from "~/channels/BaseChannel";

export default class LegacyPrivateAccountChannel extends BaseChannel {
  static channelName = "LegacyPrivateAccountChannel";
}
